import { format, isValid } from 'date-fns';
import DateEnum from './material/DatePicker/enum';
import { TagEnum } from './type';
// #region util ---------------------------------------------------------------------------
export var isUndefined = function (value) {
    return typeof value === 'undefined';
};
export var isNull = function (value) { return value === null; };
export var isString = function (value) {
    return typeof value === 'string';
};
export var isNumber = function (value) {
    return typeof value === 'number';
};
export var isBlob = function (value) { return value instanceof Blob; };
export var isArray = function (value) {
    return Array.isArray(value);
};
export var isObject = function (value) { return typeof value === 'object'; };
export var isDate = function (value) {
    return value instanceof Date ||
        (typeof value === 'object' &&
            Object.prototype.toString.call(value) === '[object Date]');
};
export var arrayEqualNotSort = function (ary1, ary2) {
    return ary1.length === ary2.length &&
        ary1.every(function (obj) { return ary2.filter(function (obj2) { return obj2 === obj; }).length === 1; });
};
// #endregion util
// #region Dataproccess ---------------------------------------------------------------------------
export var zeroFirst = function (numValue, sliceNum) {
    if (sliceNum === void 0) { sliceNum = -3; }
    return numValue < 0 ? String(numValue) : ("0000" + numValue).slice(sliceNum);
};
/** 貨幣 千分位數 */
export var toCurrency = function (fix) { return function (value) {
    if (value === void 0) { value = 0; }
    var data = parseFloat(String(value));
    if (Number.isNaN(data)) {
        return '';
    }
    var val = data.toString();
    if (fix && isNumber(fix)) {
        var fixTemp = Math.round(Math.abs(fix));
        val = parseFloat(val).toFixed(fixTemp);
    }
    var parts = val.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}; };
/** 選項轉換 */
export var option2Trans = function (options, other) {
    var trans = {};
    options.forEach(function (obj) {
        trans[obj.value] = obj.label;
    });
    return { options: options, trans: trans, other: other };
};
// #endregion Dataproccess
// #region onchange --------------------------------------------------------------------
export var inputVal = function (value) {
    return isNull(value) || isUndefined(value) ? '' : String(value);
};
export var strEmpty = function (value) { return inputVal(value) === ''; };
// DatePicker TimePicker DateTimePicker (material-ui/pickers)
export var datePickerChange = function (updateData) { return function (name, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DateEnum.daFormat; }
    return function (date) {
        var updateObj = {};
        updateObj[name] = date ? format(date, dateFormat) : null;
        if (updateData) {
            updateData(updateObj);
        }
        return updateObj;
    };
}; };
export var dateTypingChange = function (updateData, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DateEnum.daFormatP; }
    return function (date, name) {
        if (name === void 0) { name = ''; }
        var updateObj = {};
        updateObj[name + "Valid"] = isValid(date);
        if (date && isValid(date)) {
            updateObj[name] = format(date, dateFormat);
        }
        else if (date === null) {
            updateObj[name + "Valid"] = true;
            updateObj[name] = '';
        }
        if (updateData) {
            updateData(updateObj);
        }
        return updateObj;
    };
};
export var timePickerChange = function (updateData) { return function (name, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DateEnum.ti4Format; }
    return function (date) {
        return datePickerChange(updateData)(name, dateFormat)(date);
    };
}; };
export var timeTypingChange = function (updateData, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DateEnum.ti4Format; }
    return function (date, name) {
        if (name === void 0) { name = ''; }
        return dateTypingChange(updateData, dateFormat)(date, name);
    };
};
// StyleMultiline (material UI)
export var inputChange = function (updateData) { return function (e) {
    var _a;
    var updateObj = (_a = {},
        _a[e.target.name] = e.target.value,
        _a);
    if (updateData)
        updateData(updateObj);
    return updateObj;
}; };
// StyleSelect (material UI)
export var selectChange = function (updateData) { return function (e) {
    var _a;
    var updateObj = (_a = {},
        _a[e.target.name] = e.target.value,
        _a);
    if (updateData) {
        updateData(updateObj);
    }
    return updateObj;
}; };
// FormControlGen (material UI)
export var radioChange = function (updateData) { return function (e, value) {
    var _a;
    var updateObj = (_a = {}, _a[e.target.name] = value, _a);
    if (updateData) {
        updateData(updateObj);
    }
    return updateObj;
}; };
// Checkbox (material UI)
export var YNEnum;
(function (YNEnum) {
    YNEnum["\u662F"] = "Y";
    YNEnum["\u5426"] = "N";
})(YNEnum || (YNEnum = {}));
export var YNbool = [YNEnum.是, YNEnum.否];
export var checkboxChange = function (updateData) { return function (TrueVal) {
    if (TrueVal === void 0) { TrueVal = [true, false]; }
    return function (e) {
        var _a;
        var updateObj = (_a = {},
            _a[e.target.name] = e.target.checked ? TrueVal[0] : TrueVal[1],
            _a);
        if (updateData)
            updateData(updateObj);
        return updateObj;
    };
}; };
export var nameValueChange = function (updateData) { return function (_a) {
    var _b;
    var name = _a.name, value = _a.value;
    var updateObj = (_b = {}, _b[name] = value, _b);
    if (updateData)
        updateData(updateObj);
    return updateObj;
}; };
// #endregion onchange
// #region focus
export var focusControl = function (refObj) {
    var _a, _b, _c;
    if (!refObj)
        return;
    switch (refObj.tag) {
        case TagEnum.radio:
        case TagEnum.checkbox:
            (_a = refObj.ref) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = refObj.action) === null || _b === void 0 ? void 0 : _b.focusVisible();
            break;
        case TagEnum.input:
        case TagEnum.select:
        default:
            (_c = refObj.ref) === null || _c === void 0 ? void 0 : _c.focus();
            break;
    }
};
// #endregion focus
